// import Vue from 'vue'
import { BASE_URL } from '@/helpers/constants'
import axiosInstance from 'axios'
import { $snackbar } from './event-bus'
import router from './router'

const axios = axiosInstance.create({
	baseURL: BASE_URL + '/api'
})

// static token
axios.defaults.headers.common.Authorization = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjI0IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZSI6ImFkbWluIiwiZXhwIjoxNzU5NzYxNDI5fQ.yG4RrJ2OULyGUfRcbOzlNkf5VsRAStlZ5xMHNbHNcgY'

// interceptor
let controller = {};
if ('AbortController' in window) {
	controller = new AbortController();
	router.beforeEach((to, from, next) => {
		if (from.name) { controller.abort(); controller = new AbortController(); }
		next();
	});
}

const onceRequestStack = [];
axios.interceptors.request.use(configs => {
	if (configs.method && configs.method.toLowerCase() === 'get') {
		if (configs.params instanceof URLSearchParams) {
			configs.params.append('centerId', 0);
		} else if (typeof configs.params === 'object') {
			configs.params.centerId = 0;
		} else {
			configs.params = { centerId: 0 };
		}
	}
	
	if (configs.once) {
		if (!onceRequestStack.includes(configs.url)) {
			onceRequestStack.push(configs.url)
		} else if (onceRequestStack.includes(configs.url)) {
			const controller = new AbortController();
			configs.signal = controller.signal;
			controller.abort();
		}
	} else {
		configs.signal = controller.signal;
	}
	return configs
});

axios.interceptors.response.use(
	response => {
		if (onceRequestStack.includes(response.config.url)) {
			onceRequestStack.splice(onceRequestStack.indexOf(response.config.url), 1)
		}
		return response;
	},
	error => {
		if (
			(error.configs && error.configs.preventErrorHandler) ||
			error.code === 'ERR_CANCELED'
		) {
			return Promise.reject(error);
		}
		
		if (!window.navigator.onLine) {
			$snackbar.error('أنت غير متصل بالإنترنت.');
			return Promise.reject(error);
		}
		/* if (error.response.status === 401 && router.currentRoute.name !== 'login') {
			store.dispatch('auth/logout');
			router.replace({ name: 'login' })
		} */
		$snackbar.error(
			error.response?.data.message ||
			error.response?.data.error ||
			error.response?.statusText ||
			'حدث خطأ. يرجى المحاولة مرة أخرى أو التواصل مع فريق الدعم.'
		)
		return Promise.reject(error);
	}
)

export default axios
